import apiAxios from '../../services/apiAxios';
import moment from 'moment'
// import axios from 'axios'

const state = {
    documentoNumero: 0,
    apellido: '',
    nombre: '',
    fechaNacimiento: '1900-01-01',
    sexo: '',
    esCliente: false,
    celularCodigoArea: 0,
    celularNumero: 0
};

const mutations = {
    'INICIALIZAR_PARTICIPANTE'(state) {
        state.documentoNumero = 0;
        state.apellido = '';
        state.nombre = '';
        state.fechaNacimiento = '1900-01-01';
        state.sexo = '';
        state.esCliente = false;
        state.celularCodigoArea = 0;
        state.celularNumero = 0;
    },
    'SET_PARTICIPANTE'(state, participante) {
        state.documentoNumero = participante.documentoNumero;
        state.apellido = participante.apellido;        
        state.nombre = participante.nombre;
        if (participante.fechaNacimiento == '') {
            state.fechaNacimiento = '1900-01-01';
        } else {
            state.fechaNacimiento = moment(participante.fechaNacimiento).format('YYYY-MM-DD');
        }
        state.sexo = participante.sexo;
    },
    'DOCUMENTO_NUMERO'(state, documentoNumero) {
        /* Inicializamos a partir del DNI unicamente */
        state.documentoNumero = documentoNumero;
        state.apellido = '';        
        state.nombre = '';
        state.fechaNacimiento = '';
        state.sexo = '';
    },
    'SEXO'(state, sexo) {
        state.sexo = sexo;
    },
    'ES_CLIENTE'(state, esCliente) {
        state.esCliente = esCliente;
    },
    'CELULAR'(state, params) {
        state.celularCodigoArea = params.celularCodigoArea;
        state.celularNumero = params.celularNumero;
    },
};

const getters = {
    participante (state) {
        let fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');

        var participante = {
            documentoNumero: state.documentoNumero,
            apellido: state.apellido,
            nombre: state.nombre,
            fechaNacimiento,
            sexo: state.sexo,
            esCliente: state.esCliente,
            celularCodigoArea: state.celularCodigoArea,
            celularNumero: state.celularNumero
        }
        return participante;
    },
    nombreCompleto (state) {
        return state.apellido.trim() + ' ' + state.nombre.trim();
    },
};

const actions = {
    setDatosParticipante ( { commit }, participante ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARTICIPANTE');
            commit('SET_PARTICIPANTE', participante);
            resolve();
        }, error => {
            reject(error);
        })
    },
    setDocumentoParticipante ( { commit }, documentoNumero ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARTICIPANTE');
            commit('DOCUMENTO_NUMERO', documentoNumero);
            resolve();
        }, error => {
            reject(error);
        })
    },
    setSexoParticipante ( { commit }, sexo ) {
        commit('SEXO', sexo);
    },
    setEsClienteParticipante ( { commit }, esCliente ) {
        commit('ES_CLIENTE', esCliente);
    },
    setCelularParticipante ( { commit }, params ) {
        commit('CELULAR', params);
    },
    save ({ state, commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            commit('CELULAR', params);

            let evento = rootState.eventos.evento;
            let token = rootState.user.tokenString;
            let participante = {};

            let fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');

            if (state.apellido.trim() != '') {
                participante= {
                    token: token,
                    eventoId: evento.id,
                    documentoNumero: state.documentoNumero,
                    apellido: state.apellido,
                    nombre: state.nombre,
                    fechaNacimiento,
                    sexo: state.sexo,
                    esCliente: state.esCliente,
                    celularCodigoArea: state.celularCodigoArea,
                    celularNumero: state.celularNumero
                }
            } else {
                participante= {
                    token: token,
                    eventoId: evento.id,
                    documentoNumero: state.documentoNumero,
                    sexo: state.sexo,
                    esCliente: state.esCliente,
                    celularCodigoArea: state.celularCodigoArea,
                    celularNumero: state.celularNumero
                }
            }

            apiAxios.post('eventos/add-participante', participante)
            // axios.post(url, participante)             
                .then(() => resolve())
                .catch( error => {
                    let errorMessage = 'Se produjo un error al registrar el nuevo participante.'
            
                    if (error) {
                      if (error.response) {
                        if (error.response.data) {
                          errorMessage = error.response.data;
                        }
                      }
                    }
        
                    reject(errorMessage);

                    // console.log(error.response);
                    // var errorMessage = "No es posible registrar el nuevo participante.";
                    // if (error.response) {
                    //     if (error.response.data) {
                    //         if (error.response.data.message) {
                    //             errorMessage = error.response.data.message;
                    //         }
                    //     }
                    // }
                    // reject(errorMessage);
                })
        })
    },
    setParticipanteFromImage ( { commit }, params) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARTICIPANTE');

            /* Leemos el codigo(imagen) o lo procesamos via alguna API */
            var participante = {
                apellido: params.apellido,
                nombre: params.nombre,
                documentoNumero: params.documentoNumero,
                fechaNacimiento: params.fechaNacimiento,
                sexo: params.sexo
            };    
            commit('SET_PARTICIPANTE', participante);

            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/participante.js